import { useNetworkState } from "@uidotdev/usehooks";
import { CloudIcon, CloudOffIcon, CloudDownloadIcon } from "lucide-react";
import { useAppValue } from "@/stores/app-store";
import { useMediaQuery } from "@uidotdev/usehooks";
import { cn } from "@/lib/utils";

const OfflineIndicator = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const networkState = useNetworkState();
    const isSyncing = useAppValue("isSyncing");

    if (!networkState.online) {
        return (
            <div className="flex items-center gap-2 rounded-lg border border-gray-500 px-4 py-2">
                <CloudOffIcon className="h-4 w-4 stroke-gray-500" />
                <span className={cn(isMobile ? "hidden" : "text-sm text-gray-500")}>Offline</span>
            </div>
        );
    }

    if (isSyncing) {
        return (
            <div className="flex items-center gap-2 rounded-lg border border-amber-500 px-4 py-2 animate-pulse">
                <CloudDownloadIcon className="h-4 w-4 stroke-amber-500" />
                <span className={cn(isMobile ? "hidden" : "text-sm text-amber-500")}>Syncing</span>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-2 rounded-lg border border-primary px-4 py-2">
            <CloudIcon className="h-4 w-4 stroke-primary" />
            <span className={cn(isMobile ? "hidden" : "text-sm text-primary")}>Online</span>
        </div>
    );
};

export { OfflineIndicator };
